(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('facesheet-tpl', {
                parent: 'entity',
                url: '/facesheet-tpl',
                data: {
                    authorities: [],
                    pageTitle: 'FacesheetTpls'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/facesheet-tpl/list/facesheet-tpl.html',
                        controller: 'FacesheetTplController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    access: ['Auth', 'ACTIONS', function (Auth, ACTIONS) {
                        var actions = [ACTIONS.ACTION_MAIN_MENU_TEMPLATES_FACESHEET_TEMPLATE];
                        return Auth.loadActionsAccess(actions).$promise;
                    }]
                },
                onEnter: ['Auth', 'ACTIONS', 'access', function (Auth, ACTIONS, access) {
                    Auth.checkActionAuthorization(ACTIONS.ACTION_MAIN_MENU_TEMPLATES_FACESHEET_TEMPLATE, access);
                }]
            });
    }
})();
